import { Tag, Users } from "lucide-react";
import { useGetIdentity, useTranslate } from "ra-core";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";

import { FilterCategory } from "../filters/FilterCategory";
import { useActiveFilterChips } from "../misc/ActiveFilterBar";
import { ResponsiveFilters } from "../misc/ResponsiveFilters";
import { SettingsShortcut } from "../settings/SettingsShortcut";
import { useCompanyFilterBar } from "./companyFilterBar";
import { useConfigurationContext } from "../root/ConfigurationContext";

export const CompanyListFilter = () => {
  const { identity } = useGetIdentity();
  const { recordTypes } = useConfigurationContext();
  const translate = useTranslate();
  const { count, clearAll } = useActiveFilterChips(useCompanyFilterBar());
  return (
    <ResponsiveFilters activeFilters={{ count, clearAll }}>
      <FilterCategory
        icon={<Tag className="h-4 w-4" />}
        label="resources.companies.filters.record_type"
        action={<SettingsShortcut section="record_types" />}
      >
        {recordTypes.map((type) => (
          <ToggleFilterButton
            className="w-auto md:w-full justify-between h-10 md:h-8"
            label={type.label}
            key={type.value}
            value={{ record_type: type.value }}
          />
        ))}
      </FilterCategory>

      <FilterCategory
        icon={<Users className="h-4 w-4" />}
        label="resources.companies.fields.sales_id"
      >
        <ToggleFilterButton
          className="w-auto md:w-full justify-between h-10 md:h-8"
          label={translate("crm.common.me")}
          value={{ sales_id: identity?.id }}
        />
      </FilterCategory>
    </ResponsiveFilters>
  );
};
